import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Segment, Label } from 'semantic-ui-react';
import hasRESTClient from '../../hocs/has-rest-client';
import NegativeKeywordsInput from '../../components/negative-keywords-input';

const titleStyle = { paddingBottom: 5, display: 'block' };

export class NegativeKeywordsSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      keywords: null,
      error: null,
      isSaving: false,
    };
  }

  componentDidMount() {
    const { restClient, campaignId } = this.props;
    return restClient.get(`campaigns/${campaignId}`)
      .then(response => this.setState({
        keywords: _.get(response, 'data.data.attributes.negativeKeywords') || '',
      }))
      .catch(() => this.setState({ error: 'Could not load negative keywords.' }));
  }

  // Saves each add/remove straight away, putting the chips back if it fails.
  onChange = keywords => {
    const { restClient, campaignId } = this.props;
    const previous = this.state.keywords;
    this.setState({ keywords, isSaving: true, error: null });
    const payload = { data: { attributes: { negativeKeywords: keywords } } };
    return restClient.patch(`campaigns/${campaignId}`, payload)
      .then(() => this.setState({ isSaving: false }))
      .catch(() => this.setState({ keywords: previous, isSaving: false, error: 'Could not save. Please try again.' }));
  }

  render() {
    const { keywords, error, isSaving } = this.state;

    return (
      <Segment>
        <h3 style={titleStyle}>Negative Keywords</h3>
        <p>Posts, TikToks and stories whose caption or hashtags contain any of these keywords are left out of reports.
          You can enter multiple keywords separated by commas.</p>

        {
          _.isNull(keywords)
            ? error && <Label basic color="red">{error}</Label>
            : <NegativeKeywordsInput
              hideLabel
              keywords={keywords}
              onChange={this.onChange}
              isSaving={isSaving}
              error={error}
            />
        }
      </Segment>
    );
  }
}

NegativeKeywordsSettings.propTypes = {
  restClient: PropTypes.func.isRequired,
  campaignId: PropTypes.string.isRequired,
};

export default hasRESTClient(NegativeKeywordsSettings);



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-negative-keywords-settings/index.js
 **/